import { render, staticRenderFns } from "./messageBody.vue?vue&type=template&id=125898a8&"
import script from "./messageBody.vue?vue&type=script&lang=js&"
export * from "./messageBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports